import { createSlice } from "@reduxjs/toolkit";
import { setIsContactScanDataPresent, setContactScanData, setApolloContactsData, setApolloDropdownData } from "./profileContacts.action";

const profileContactSlice = createSlice({
  name: "profileContactData",
  initialState: {
    isContactScanDataPresent: false,
    contactScanData: {},
    apolloContactsData: {},
    apolloDropdownData: {},
  },
  reducers: {
    isContactScanDataHandler: setIsContactScanDataPresent,
    contactScanDataHandler: setContactScanData,
    apolloContactsDataHandler: setApolloContactsData,
    apolloDropdownDataHandler: setApolloDropdownData,
  },
});

export const { isContactScanDataHandler, contactScanDataHandler, apolloContactsDataHandler, apolloDropdownDataHandler } = profileContactSlice.actions;

export default profileContactSlice.reducer;
